module.exports = __webpack_public_path__ + "static/tukutuku-a140874c2d1293dc7ad38948680df15c.png";